<template>
    <div>
        <navBar></navBar>
        <navigation></navigation>
        <router-view></router-view>
        <footers></footers>
    </div>
</template>
<script>
import navBar from "@/components/navBar/index.vue"
import footers from "@/components/footers/index.vue"
import navigation from "@/components/navigation/index.vue"
export default {
    data() {
        return {

        }
    },
    components: {
        navBar,
        footers,
        navigation
    },
}
</script>
<style lang="less">
    
</style>